"use client"

import { ChakraProvider } from "@chakra-ui/react"
import system from "configs/theme/theme"
import { ThemeProvider } from "next-themes"
import { memo, type ReactNode } from "react"

type Props = {
  children: ReactNode
}

const RootProvider = ({ children }: Props) => {
  return (
    <ChakraProvider value={system}>
      <ThemeProvider
        scriptProps={{
          suppressHydrationWarning: true,
        }}
        attribute="class"
        disableTransitionOnChange
        forcedTheme="light"
        defaultTheme="light"
      >
        {children}
      </ThemeProvider>
    </ChakraProvider>
  )
}

export default memo(RootProvider)
